import cn from 'clsx'
import Label from 'components/Luxkit/Label'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { BestOfPrimaryColour, BestOfSecondaryColour } from './BestOfConstants'
import BestOfText from './BestOfText'
import BestOfLabelContext from './BestOfLabelContext'

const BestOfLabel = styled(Label)`
  &.variant-dark {
    background-color: ${BestOfPrimaryColour} !important;
    border-color: ${BestOfPrimaryColour} !important;
    color: ${BestOfSecondaryColour} !important;
  }

  &.variant-light {
    background-color: ${BestOfSecondaryColour} !important;
    border-color: ${BestOfSecondaryColour} !important;
    color: ${BestOfPrimaryColour} !important;
  }
`

interface Props {
  variant: 'dark' | 'light';
  className?: string;
}

function BestOf2024Label(props: Props) {
  const showBestOf = useContext(BestOfLabelContext)
  if (!showBestOf) {
    return null
  }

  return <BestOfLabel
    className={cn(props.className, `variant-${props.variant}`)}
    kind="primary"
    variant="highlight"
  >
    <BestOfText />
  </BestOfLabel>
}

export default BestOf2024Label
